// ** Navigation imports
import Routes from "./apps";

// ** Merge & Export
export default {
	mainRoutes: Routes?.mainRoutes,
	horptRoutes: Routes?.horptRoutes,
	hoadmRoutes: Routes?.hoadmRoutes,
};
